import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import logger from 'redux-logger';

import reducer from './reducers';
import utils from './lib/utils';

function configureStore(initialState) {
    const middlewares = [thunkMiddleware];
  
    // Log only in development
    if (process.env.NODE_ENV === 'development') {
      middlewares.push(logger);
    }
  
    const enhancer = compose(
      applyMiddleware(...middlewares),
    );
    return createStore(reducer, initialState, enhancer);
}

const store = configureStore({
  auth: {
    userid: utils.getCookie('user'),
  },
});

export default store;